import React from "react";
import {
  PeopleOutline,
  ReturnUpBackOutline,
  CartOutline,
  ReceiptOutline,
  LogOutOutline,
  CashOutline,
  BookmarksOutline,
} from "react-ionicons";
import stylesASAP from "./stylesASAP";
import { Modal } from "react-bootstrap";
import { ArrowBackCircle } from "react-ionicons";
import constantURI from "../URI";
import _post from "../Functions/Post";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesMed from "../MedRep/stylesMed";
import Geocode from "react-geocode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FcManager,
  FcBarChart,
  FcBullish,
  FcBearish,
  FcCalendar,
  FcComboChart,
  FcSurvey,
  FcSalesPerformance,
  FcNews,
  FcSynchronize,
  FcCancel,
  FcShop,
  FcRedo,
  FcProcess,
  FcRefresh,
  FcNook,
  FcShipped,
  FcPaid,
} from "react-icons/fc";
import {
  faUser,
  faMapMarkerAlt,
  faPhone,
  faCheckCircle,
  faFileInvoiceDollar,
  faScaleBalanced,
  faCreditCard,
} from "@fortawesome/free-solid-svg-icons";

export default class TransactionsPage extends React.Component {
  constructor() {
    super();
    this.state = {
      alertUndefined: false,
      showAlertChange: false,
      showAlertSync: false,
      clients: [],
      clientsCopy: [],
      loading: true,
      data: [],
      noData: true,
      backShow: true,
      token: "",
      showAlertCancel: false,
      showAlertChange: false,
      showAlertAging: false,
      authenticate: false,
      savedisable: true,
      landing: "",
      clientType: [
        { id: 0, name: "Customers", URL: "GetClients?token=", LS: "Clients" },
        { id: 1, name: "Vendors", URL: "GetVendors?token=", LS: "Vendors" },
      ],
      isSchedule: "",
      currentType: -1,
      dateOut: "",
      dateIn: "",
      timeIn: "",
      timeOut: "",
      latitudeOut: "",

      longitudeIn: "",

      disableDate: false,
      disableout: false,

      reason: "",
      Date: new Date().toISOString().substring(0, 10),
      scheduledClient: "",
      customer: "",
      scheduledclientid: "",
      alertdanger: false,
      disablereason: false,
      visitin: [],
      cancelReason: [],
      reasonDisable: false,
      vIn: {},
      count: 0,
      dailySummaryReport: [],
      localDailyVisits: [],
      clientDetail: {},
      username: "",
      CashSales: true,
      dateVisitIn: "",
      dateVisitOut: "",
      timeVisitIn: "",
      timeVisitOut: "",
      longitudeVisitIn: "",
      latitudeVisitIn: "",
      longitudeVisitOut: "",
      latitudeVisitOut: "",
      disableO: false,
      disableI: false,
      SelectedVisitCode: "",
      visits: [],
      clientLocation: [],
      locationObject: {},
      objectVisits: {},
      SelectedClient: 0,
      settingArray: [],
      UserId: 0,
      partnerid: -1,
      locationDisabled: false,
      cancelRoute: true,
      countTrans: 0,
    };
  }

  // Navigate to CompetitorDataLogger for the currently selected client
  logCompetitor = () => {
    this.unblock();
    // Ensure client context is set for the logger
    localStorage.setItem("SelectedClient", JSON.stringify(this.state.SelectedClient));
    localStorage.setItem("SelectedClientName", JSON.stringify(this.state.landing));
    localStorage.setItem("SelectedClientDetails", JSON.stringify(this.state.clientDetail));
    this.props.history.push("/CompetitorDataLogger");
  };

  featureEnabled = (key) => {
    const setting = this.state.settingArray.find((st) => st.key === key);
    if (!setting) return true;
    const v = String(setting.value).toLowerCase();
    return v === "1" || v === "true" || v === "enabled";
  };

  componentWillUnmount() {
    if (this.unblock) {
      this.unblock();
    }
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";
    localStorage.setItem("unsycJournal", JSON.stringify(1));
    const { history } = this.props;
    this.unblock = history.block(() => {
      // Return false to deny the navigation
      return false;
    });
    const isVendor = JSON.parse(localStorage.getItem("isVendor"));
    // if is vendor
    if (isVendor) {
      await this.setState({ currentType: 1 });
    }
    // if is client
    else {
      await this.setState({ currentType: 0 });
    }
    const token = localStorage.getItem("Token");
    const landing = localStorage.getItem("SelectedClientName");
    const username = localStorage.getItem("Username");
    const clientDetail = JSON.parse(
      localStorage.getItem("SelectedClientDetails")
    );
    const SelectedClient = JSON.parse(localStorage.getItem("SelectedClient"));
    const isSchedule = localStorage.getItem("isSchedule");
    const date = new Date();
    const visitsSend = JSON.parse(localStorage.getItem("visits"));
    const visitin = localStorage.getItem("VisitIn");
    const selectedid = localStorage.getItem("SelectedVisitId");
    const disablereason = localStorage.getItem("disablereason");
    const cancelReason = localStorage.getItem("CancelReason");
    const count = localStorage.getItem("UnsyncedVisitCount");
    const visits = localStorage.getItem("UnsyncedVisitCount");
    const disableI = JSON.parse(localStorage.getItem("disableI"));
    const LongitudeClient = JSON.parse(localStorage.getItem("LongitudeClient"));
    const LatitudeClient = JSON.parse(localStorage.getItem("LatitudeClient"));
    const settingArray = JSON.parse(localStorage.getItem("SettingArray"));
    const clientLocation = JSON.parse(localStorage.getItem("clientLocation"));
    const dailySummaryReport = JSON.parse(
      localStorage.getItem("DailySummaryReport")
    );
    const localDailyVisits = JSON.parse(
      localStorage.getItem("LocalDailyVisits")
    );

    const cancelRoute = JSON.parse(localStorage.getItem("cancelRoute"));
    const SelectedVisitCode = JSON.parse(
      localStorage.getItem("SelectedVisitCode")
    );
    const UserId = JSON.parse(localStorage.getItem("UserId"));
    const backupVisits = JSON.parse(localStorage.getItem("backupVisits"));
    const partnerid = JSON.parse(localStorage.getItem("partnerid"));
    const countTrans = JSON.parse(localStorage.getItem("countTrans"));
    await this.setState({
      visits: visitsSend !== null ? visitsSend : [],
      SelectedClient: SelectedClient,
      landing: JSON.parse(landing),
      username: JSON.parse(username),
      isSchedule: JSON.parse(isSchedule),
      count: JSON.parse(count),
      SelectedVisitCode: SelectedVisitCode,
      scheduledclientid: JSON.parse(selectedid),
      disablereason: JSON.parse(disablereason),
      visitin: JSON.parse(visitin),
      cancelReason: JSON.parse(cancelReason),
      token: JSON.parse(token),
      clientDetail: clientDetail,
      disableI: disableI,
      settingArray: settingArray,
      dailySummaryReport:
        dailySummaryReport.length === 0
          ? [{ ordered: 0, visited: 0, collection: 0, OOR: 0 }]
          : dailySummaryReport,
      localDailyVisits: localDailyVisits,
      UserId: UserId,
      partnerid: partnerid,
      LongitudeClient: LongitudeClient,
      LatitudeClient: LatitudeClient,
      clientLocation: clientLocation,
      backupVisits: backupVisits !== null ? backupVisits : [],
      cancelRoute:
        cancelRoute !== undefined && cancelRoute !== null ? cancelRoute : true,
      countTrans: countTrans !== null ? countTrans : 0,
    });
    console.log(this.state.cancelRoute);
    // its array of objects for visit in/out
    if (this.state.visitin !== null) {
      this.state.visitin.map(async (item) => {
        if (item.id === this.state.scheduledclientid) {
          this.setState({
            dateIn: item.dateIn,
            dateOut: item.dateOut,
            latitudeIn: item.latitudeIn,
            latitudeOut: item.latitudeout,
            longitudeIn: item.longitudeIn,
            longitudeOut: item.longitudeOut,
            disableDate: item.disableDate,
            disableout: item.disableout,
            timeIn: item.timeIn,
            timeOut: item.timeOut,
          });
        }
      });
    } else {
      this.setState({ visitin: [] });
    }

    if (this.state.clientLocation === null) {
      this.setState({ clientLocation: [] });
    }
    // its array of object for disable cancel reason
    if (this.state.cancelReason !== null) {
      this.state.cancelReason.map(async (item) => {
        if (item.id === this.state.scheduledclientid) {
          await this.setState({ reasonDisable: item.reasonDisable });
        }
      });
    } else {
      this.setState({ cancelReason: [] });
    }
    //if date time different than today or null please fill out the states
    if (
      this.state.dateIn !== date.toISOString().substring(0, 10) &&
      this.state.dateIn !== null
    ) {
      await this.setState({
        dateIn: "",
        timeIn: "",
        addressDateIn: "",
        latitudeIn: "",
        longitudeIn: "",
      });
    }
    //if date time different than today or null please fill out the states
    if (
      this.state.dateOut !== date.toISOString().substring(0, 10) &&
      this.state.dateOut !== null
    ) {
      await this.setState({
        dateOut: "",
        timeOut: "",
        addressDateOut: "",
        latitudeOut: "",
        longitudeOut: "",
      });
    }
    //for disable
    if (this.state.dateIn === null || this.state.dateIn === "") {
      this.setState({ disableDate: false });
    } else {
      this.setState({ disableDate: true });
    }
    if (this.state.dateOut === null || this.state.dateOut === "") {
      this.setState({ disableout: false });
    } else {
      this.setState({ disableout: true });
    }
    this.setState({ backShow: this.props.show });
    const client = localStorage.getItem("Clients");
    const scheduledclients = localStorage.getItem("ScheduledClients");
    this.setState({
      clients: JSON.parse(client),
      scheduledClient: JSON.parse(scheduledclients),
      loading: false,
    });
    if (this.state.settingArray.length === 0) {
      this.setState({
        disableI: true,
        disableO: false,
      });
    }
    //await ASAPAuthenticate().then((response) => { this.setState({ authenticate: response }) });
    //const clientURL = constantURI() + "GetScheduleClients?token=" + this.state.token+ "&user=" + this.state.username + "&date=" + this.state.Date;
    //const getClients = constantURI() + this.state.clientType[this.state.currentType].URL + this.state.token+ "&user=" + this.state.username;
    //if (this.state.authenticate) {
    //    await _post(getClients).then((response) => {
    //        return response.json().then(async (data) => {
    //            if (data.result !== undefined) {
    //                this.setState({ clients: data.result, clientsCopy: data.result, loading: false })
    //                localStorage.setItem(this.state.clientType[this.state.currentType].LS, JSON.stringify(data.result));
    //            }
    //            else {
    //                this.setState({ alertUndefined: true });
    //            }
    //        })
    //    })
    //    await _post(clientURL).then((response) => {
    //        return response.json().then(async (data) => {
    //            if (data.result !== undefined) {
    //                this.setState({ customer: data.result })
    //                localStorage.setItem('ScheduledClients', JSON.stringify(this.state.customer));
    //            }
    //            else {
    //                this.setState({ alertUndefined: true });
    //            }
    //        })
    //    })
    //} else {
    //const client = localStorage.getItem('Clients');
    //const scheduledclients = localStorage.getItem('ScheduledClients');
    //this.setState({ clients: JSON.parse(client), scheduledClient: JSON.parse(scheduledclients), loading: false });
    //}
  }
  showAlertAging = async () => {
    this.unblock();
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });

    if (this.state.authenticate) {
      // await _post().then((response) => {
      //     return response.json().then(async (data) => {
      //         if (data.result !== undefined) {
      //             this.setState({ showAlertAging: true });
      //         }
      //     })
      // });
      this.setState({ showAlertAging: true });
    } else {
      alert("Please connect to the internet.");
    }
  };
  closeAlertAging = () => {
    this.unblock();
    this.setState({ showAlertAging: false });
  };

  //logout
  closeAlertChange = () => {
    this.unblock();
    this.setState({ showAlertChange: false });
  };

  // cancel reason
  closeAlertCancel = () => {
    this.unblock();
    this.setState({ showAlertCancel: false });
  };

  //logout
  showAlertChange = () => {
    this.unblock();
    this.setState({ showAlertChange: true });
  };

  // cancel reason
  showAlertCancel = () => {
    this.unblock();
    this.setState({ showAlertCancel: true });
  };

  // sync
  showAlertSync = () => {
    this.unblock();
    this.setState({ showAlertSync: true });
  };

  //sync
  closeAlertsync = () => {
    this.unblock();
    this.setState({ showAlertSync: false });
  };

  moreInfo = () => {
    this.unblock();
    this.props.history.push("./MoreInfo");
  };

  statmentofaccount = () => {
    this.unblock();
    this.props.history.push("./Report");
  };

  EditClient = (name) => {
    this.unblock();
    localStorage.setItem("SelectedClientName", JSON.stringify(name));
    this.props.history.push("./EditClient");
  };

  // if e.target is empty
  onChangeReason = async (e) => {
    this.unblock();
    await this.setState({ reason: e.target.value });
    if (e.target.value !== "") {
      await this.setState({ alertdanger: false, savedisable: false });
    }
  };

  // save cancel reason
  SaveReason = async () => {
    this.unblock();
    const d = new Date();
    d.setDate(d.getDate());

    const updateCancelReason =
      constantURI() +
      "UpdateCancelReason?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&LineId=" +
      this.state.scheduledclientid +
      "&reason=" +
      this.state.reason +
      "&inv=" +
      this.state.countTrans;
    var temp = this.state.visitin;

    // insert fields to the object

    this.state.vIn.reasondisable = true;
    this.state.vIn.id = this.state.scheduledclientid;
    this.state.vIn.cancelUrl = updateCancelReason;
    this.state.vIn.visit = "cancel";
    this.state.vIn.name = this.state.landing;
    this.state.vIn.code = this.state.SelectedVisitCode;
    this.state.vIn.dateIn = d.toISOString().substring(0, 10);
    this.state.vIn.countTrans = 0;
    this.state.vIn.timeIn =
      ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);
    this.state.vIn.dateOut = d.toISOString().substring(0, 10);
    this.state.vIn.timeOut =
      ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);
    // puch the ojbect inside the array

    await temp.push(this.state.vIn);

    await this.setState({ visitin: temp });

    localStorage.setItem("VisitIn", JSON.stringify(this.state.visitin));
    // arrray map + condition
    if (this.state.visitin !== null) {
      this.state.visitin.map(async (item) => {
        if (item.id === this.state.scheduledclientid) {
          await this.setState({ reasondisable: item.reasondisable });
        }
      });
    } else {
      this.setState({ visitin: [] });
    }
    if (this.state.reason === "") {
      this.setState({ alertdanger: true });
    } else {
      this.setState({ alertdanger: false });
      this.setState({ count: this.state.count + 1 });
      localStorage.setItem("VisitIn", JSON.stringify(this.state.visitin));
      await localStorage.setItem(
        "UnsyncedVisitCount",
        JSON.stringify(this.state.count)
      );
      await localStorage.setItem(
        "UnsyncedVisitDay",
        JSON.stringify(this.state.visitin)
      );
      await this.LocalDailyVisits(false);
      this.props.history.push("./Client");
    }
  };

  SaveReason2 = async () => {
    this.unblock();

    const d = new Date();
    d.setDate(d.getDate());
    const AddOutRoutVisit =
      constantURI() +
      "AddOutRoutVisit?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&partnerid=" +
      this.state.partnerid +
      "&name=" +
      this.state.landing +
      "&reason=" +
      this.state.reason +
      "&checkIn=" +
      d.toISOString().substring(0, 10) +
      " " +
      ("0" + d.getHours()).slice(-2) +
      d.toISOString().substring(13, 19) +
      "&checkOut=" +
      d.toISOString().substring(0, 10) +
      " " +
      ("0" + d.getHours()).slice(-2) +
      d.toISOString().substring(13, 19) +
      "&longIn=" +
      "" +
      "&longOut=" +
      "" +
      "&latIn=" +
      "" +
      "&latOut=" +
      "" +
      "&customerId=" +
      this.state.SelectedClient;
    var temp = this.state.visits;
    var backup = this.state.backupVisits;
    // insert fields to the object

    this.state.objectVisits.reasondisable = true;
    this.state.objectVisits.id = this.state.SelectedClient;
    this.state.objectVisits.Url = AddOutRoutVisit;
    this.state.objectVisits.visit = "cancel";
    this.state.objectVisits.name = this.state.landing;
    this.state.objectVisits.code = this.state.SelectedVisitCode;
    this.state.objectVisits.dateVisitIn = d.toISOString().substring(0, 10);
    this.state.objectVisits.timeVisitIn =
      ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);
    this.state.objectVisits.dateVisitOut = d.toISOString().substring(0, 10);
    this.state.objectVisits.timeVisitOut =
      ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);
    // puch the ojbect inside the array

    await temp.push(this.state.objectVisits);
    await backup.push(this.state.objectVisits);
    await this.setState({ visits: temp, backupVisits: backup });

    localStorage.setItem("visits", JSON.stringify(this.state.visits));
    localStorage.setItem(
      "backupVisits",
      JSON.stringify(this.state.backupVisits)
    );
    // arrray map + condition
    if (this.state.visits !== null) {
      this.state.visits.map(async (item) => {
        if (item.id === this.state.SelectedClient) {
          await this.setState({ reasondisable: item.reasondisable });
        }
      });
    } else {
      this.setState({ visits: [] });
    }

    if (this.state.backupVisits !== null) {
      this.state.backupVisits.map(async (item) => {
        if (item.id === this.state.SelectedClient) {
          await this.setState({ reasondisable: item.reasondisable });
        }
      });
    } else {
      this.setState({ backupVisits: [] });
    }
    if (this.state.reason === "") {
      this.setState({ alertdanger: true });
    } else {
      this.setState({ alertdanger: false });
      this.setState({ count: this.state.count + 1 });
      localStorage.setItem("visits", JSON.stringify(this.state.visits));
      localStorage.setItem(
        "backupVisits",
        JSON.stringify(this.state.backupVisits)
      );
      await localStorage.setItem(
        "UnsyncedVisitCount",
        JSON.stringify(this.state.count)
      );
      await localStorage.setItem(
        "UnsyncedVisitDayRoute",
        JSON.stringify(this.state.visits)
      );
      await this.LocalDailyVisits(false);
      this.props.history.push("./Client");
    }
  };

  DailySummaryReport = async () => {
    await this.state.dailySummaryReport[0].visited++;
    await localStorage.setItem(
      "DailySummaryReport",
      JSON.stringify(this.state.dailySummaryReport)
    );
  };

  LocalDailyVisits = async (visited) => {
    var temp = {};
    temp.name = this.state.landing;
    temp.code = this.state.clientDetail.ref;
    temp.visited = visited;
    temp.in = this.state.dateIn + " " + this.state.timeIn;
    temp.out = this.state.dateOut + " " + this.state.timeOut;
    await this.state.localDailyVisits.push(temp);
    await localStorage.setItem(
      "LocalDailyVisits",
      JSON.stringify(this.state.localDailyVisits)
    );
  };

  // visit in
  DateIn = async () => {
    this.unblock();

    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      await navigator.geolocation.getCurrentPosition(async (position) => {
        await this.setState({
          latitudeIn: position.coords.latitude,
          longitudeIn: position.coords.longitude,
        });
        await localStorage.setItem(
          "LatitudeIn",
          JSON.stringify(this.state.latitudeIn)
        );
        await localStorage.setItem(
          "LongitudeIn",
          JSON.stringify(this.state.longitudeIn)
        );
        //await this.setState({ longitudeOut: this.props.coords.longitude, latitudeOut: this.props.coords.latitude });
        // current date
        const d = new Date();
        d.setDate(d.getDate());
        await this.setState({ disableDate: true });
        // array tmep
        var temp = this.state.visitin;

        // insert fields to the object
        this.state.vIn.dateIn = d.toISOString().substring(0, 10);
        this.state.vIn.timeIn =
          ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);
        this.state.vIn.disableDate = true;
        this.state.vIn.id = this.state.scheduledclientid;
        this.state.vIn.longitudeIn = this.state.longitudeIn;
        this.state.vIn.latitudeIn = this.state.latitudeIn;
        this.state.vIn.name = this.state.landing;
        this.state.vIn.code = this.state.SelectedVisitCode;

        // push the objects to the array
        await temp.push(this.state.vIn);

        await this.setState({ visitin: temp });
        // conditin to setstate
        if (this.state.visitin !== null) {
          this.state.visitin.map(async (item) => {
            if (item.id === this.state.scheduledclientid) {
              this.setState({
                dateIn: item.dateIn,
                latitudeIn: item.latitudeIn,
                longitudeIn: item.longitudeIn,
                disableDate: item.disableDate,
                timeIn: item.timeIn,
              });
              localStorage.setItem("DateIn", JSON.stringify(this.state.dateIn));
              localStorage.setItem("TimeIn", JSON.stringify(this.state.timeIn));
            }
          });
        } else {
          this.setState({ visitin: [] });
        }

        const updateCancelReason =
          constantURI() +
          "UpdateCancelReason?token=" +
          this.state.token +
          "&user=" +
          this.state.username +
          "&LineId=" +
          this.state.scheduledclientid +
          "&checkIn=" +
          this.state.dateIn +
          " " +
          this.state.timeIn +
          "&longIn=" +
          this.state.longitudeIn +
          "&latIn=" +
          this.state.latitudeIn +
          "&inv=" +
          this.state.countTrans;
        await temp.map(async (item, index) => {
          const lastIndex = temp.length - 1;
          this.state.vIn = temp[lastIndex];
          if (item.id === this.state.scheduledclientid) {
            // insert fields to tge last object of the array

            this.state.vIn.UrlIn = updateCancelReason;
          }
        });
        await this.setState({ visitin: temp });
        this.setState({ count: this.state.count + 1 });
        localStorage.setItem("VisitIn", JSON.stringify(this.state.visitin));
        await localStorage.setItem(
          "UnsyncedVisitCount",
          JSON.stringify(this.state.count)
        );
        await localStorage.setItem(
          "UnsyncedVisitDay",
          JSON.stringify(this.state.visitin)
        );
      });
    } else {
      alert("No internet , No location");
      // current date
      const d = new Date();
      d.setDate(d.getDate());
      await this.setState({ disableDate: true });
      // array tmep
      var temp = this.state.visitin;

      // insert fields to the object
      this.state.vIn.dateIn = d.toISOString().substring(0, 10);
      this.state.vIn.timeIn =
        ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);
      this.state.vIn.disableDate = true;
      this.state.vIn.id = this.state.scheduledclientid;
      this.state.vIn.longitudeIn = this.state.longitudeIn;
      this.state.vIn.latitudeIn = this.state.latitudeIn;
      // push the objects to the array
      await temp.push(this.state.vIn);

      await this.setState({ visitin: temp });
      // conditin to setstate
      if (this.state.visitin !== null) {
        this.state.visitin.map(async (item) => {
          if (item.id === this.state.scheduledclientid) {
            this.setState({
              dateIn: item.dateIn,
              latitudeIn: item.latitudeIn,
              longitudeIn: item.longitudeIn,
              disableDate: item.disableDate,
              timeIn: item.timeIn,
            });
            localStorage.setItem("DateIn", JSON.stringify(this.state.dateIn));
            localStorage.setItem("TimeIn", JSON.stringify(this.state.timeIn));
          }
        });
      } else {
        this.setState({ visitin: [] });
      }

      const updateCancelReason =
        constantURI() +
        "UpdateCancelReason?token=" +
        this.state.token +
        "&user=" +
        this.state.username +
        "&LineId=" +
        this.state.scheduledclientid +
        "&checkIn=" +
        this.state.dateIn +
        " " +
        this.state.timeIn +
        "&longIn=" +
        this.state.longitudeIn +
        "&latIn=" +
        this.state.latitudeIn +
        "&inv=" +
        this.state.countTrans;
      await temp.map(async (item, index) => {
        const lastIndex = temp.length - 1;
        this.state.vIn = temp[lastIndex];
        if (item.id === this.state.scheduledclientid) {
          // insert fields to tge last object of the array

          this.state.vIn.UrlIn = updateCancelReason;
        }
      });
      await this.setState({ visitin: temp });
      this.setState({ count: this.state.count + 1 });
      localStorage.setItem("VisitIn", JSON.stringify(this.state.visitin));
      await localStorage.setItem(
        "UnsyncedVisitCount",
        JSON.stringify(this.state.count)
      );
      await localStorage.setItem(
        "UnsyncedVisitDay",
        JSON.stringify(this.state.visitin)
      );
    }
  };

  //visit out
  DateOut = async () => {
    this.unblock();
    //await ASAPAuthenticate().then((response) => { this.setState({ authenticate: response }) });
    //if (this.state.authenticate) {
    //    // get the coords
    //    await navigator.geolocation.getCurrentPosition(async (position) => {
    //        //current date
    //        const d = new Date();
    //        d.setDate(d.getDate());

    //        await this.setState({ disableout: true });
    //        // array temp
    //        var temp = this.state.visitin;
    //        // last object in array
    //        await temp.map(async (item, index) => {
    //            const lastIndex = temp.length - 1;
    //            this.state.vIn = temp[lastIndex];
    //            if (item.id === this.state.scheduledclientid) {
    //                // insert fields to the last object of array
    //                this.state.vIn.dateOut = d.toISOString().substring(0, 10);
    //                this.state.vIn.timeOut = ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);
    //                this.state.vIn.disableout = true;
    //                this.state.vIn.id = this.state.scheduledclientid;
    //            }

    //        })

    //        await this.setState({ visitin: temp });
    //        // insert field to the object
    //        this.state.vIn.latitudeout = position.coords.latitude;
    //        this.state.vIn.longitudeOut = position.coords.longitude;
    //        localStorage.setItem('VisitIn', JSON.stringify(this.state.visitin));

    //        if (this.state.visitin !== null) {
    //            this.state.visitin.map(async (item) => {
    //                if (item.id === this.state.scheduledclientid) {
    //                    this.setState({ dateOut: item.dateOut, latitudeOut: item.latitudeout, longitudeOut: item.longitudeOut, disableout: item.disableout, timeOut: item.timeOut })
    //                }

    //            })
    //        } else {
    //            this.setState({ visitin: [] })
    //        }
    //        // api push to odoo
    //        const updateCancelReason = constantURI() + "UpdateCancelReason?token=" + this.state.token+ "&user=" + this.state.username + "&LineId=" + this.state.scheduledclientid + "&checkOut=" + this.state.dateOut + " " + this.state.timeOut + "&longOut=" + this.state.longitudeOut + "&latOut=" + this.state.latitudeOut;
    //        if (this.state.authenticate) {
    //            await _post(updateCancelReason).then(() => {

    //                // push to client
    //                this.props.history.push("/Client");
    //            });
    //        } else {
    //            alert('No Internet Connection! Sync with Odoo when reconnected to the Internet.');
    //        }
    //        //await this.setState({ longitudeOut: this.props.coords.longitude, latitudeOut: this.props.coords.latitude });

    //    });
    //    // if offline
    //}

    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      const count = localStorage.getItem("UnsyncedPunchCount");
      await navigator.geolocation.getCurrentPosition(async (position) => {
        await this.setState({
          latitudeOut: position.coords.latitude,
          longitudeOut: position.coords.longitude,
        });
        await localStorage.setItem(
          "LatitudeOut",
          JSON.stringify(this.state.latitudeOut)
        );
        await localStorage.setItem(
          "LongitudeOut",
          JSON.stringify(this.state.longitudeOut)
        );

        this.unblock();
        // current date
        const d = new Date();
        d.setDate(d.getDate());

        await this.setState({ disableout: true });
        // array temp
        var temp = this.state.visitin;
        // lastobject of the array
        await temp.map(async (item, index) => {
          const lastIndex = temp.length - 1;
          this.state.vIn = temp[lastIndex];
          if (item.id === this.state.scheduledclientid) {
            // insert fields to tge last object of the array
            this.state.vIn.dateOut = d.toISOString().substring(0, 10);
            this.state.vIn.timeOut =
              ("0" + d.getHours()).slice(-2) +
              d.toISOString().substring(13, 19);
            this.state.vIn.disableout = true;
            this.state.vIn.id = this.state.scheduledclientid;
            this.state.vIn.longitudeOut = this.state.longitudeOut;
            this.state.vIn.latitudeOut = this.state.latitudeOut;
            this.state.vIn.visit = "visited";
            this.state.vIn.countTrans = this.state.countTrans;
          }
        });

        await this.setState({ visitin: temp });
        await localStorage.setItem("countTrans", JSON.stringify(0));
        localStorage.setItem("VisitIn", JSON.stringify(this.state.visitin));
        // condition tosxet state
        if (this.state.visitin !== null) {
          this.state.visitin.map(async (item) => {
            if (item.id === this.state.scheduledclientid) {
              this.setState({
                dateOut: item.dateOut,
                latitudeOut: item.latitudeOut,
                longitudeOut: item.longitudeOut,
                disableout: item.disableout,
                timeOut: item.timeOut,
              });
              localStorage.setItem(
                "DateOut",
                JSON.stringify(this.state.dateOut)
              );
              localStorage.setItem(
                "TimeOut",
                JSON.stringify(this.state.timeOut)
              );
            }
          });
        } else {
          this.setState({ visitin: [] });
        }

        const updateCancelReason =
          constantURI() +
          "UpdateCancelReason?token=" +
          this.state.token +
          "&user=" +
          this.state.username +
          "&LineId=" +
          this.state.scheduledclientid +
          "&checkOut=" +
          this.state.dateOut +
          " " +
          this.state.timeOut +
          "&longOut=" +
          this.state.longitudeOut +
          "&latOut=" +
          this.state.latitudeOut +
          "&inv=" +
          this.state.countTrans;
        await temp.map(async (item, index) => {
          const lastIndex = temp.length - 1;
          this.state.vIn = temp[lastIndex];
          if (item.id === this.state.scheduledclientid) {
            // insert fields to tge last object of the array

            this.state.vIn.UrlOut = updateCancelReason;
          }
        });
        await this.setState({ visitin: temp });
        localStorage.setItem("VisitIn", JSON.stringify(this.state.visitin));
        this.setState({ count: this.state.count + 1 });
        await localStorage.setItem(
          "UnsyncedVisitCount",
          JSON.stringify(this.state.count)
        );
        await localStorage.setItem(
          "UnsyncedVisitDay",
          JSON.stringify(this.state.visitin)
        );
        await this.DailySummaryReport();
        await this.LocalDailyVisits(true);
        this.props.history.push("./Client");
      });
    } else {
      alert("No Internet , No Location !");
      this.unblock();
      // current date
      const d = new Date();
      d.setDate(d.getDate());

      await this.setState({ disableout: true });
      // array temp
      var temp = this.state.visitin;
      // lastobject of the array
      await temp.map(async (item, index) => {
        const lastIndex = temp.length - 1;
        this.state.vIn = temp[lastIndex];
        if (item.id === this.state.scheduledclientid) {
          // insert fields to tge last object of the array
          this.state.vIn.dateOut = d.toISOString().substring(0, 10);
          this.state.vIn.timeOut =
            ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);
          this.state.vIn.disableout = true;
          this.state.vIn.id = this.state.scheduledclientid;
          this.state.vIn.latitudeOut = this.state.latitudeOut;
          this.state.vIn.longitudeOut = this.state.longitudeOut;
          this.state.vIn.visit = "visited";
          this.state.vIn.countTrans = this.state.countTrans;
        }
      });

      await this.setState({ visitin: temp });
      await localStorage.setItem("countTrans", JSON.stringify(0));
      localStorage.setItem("VisitIn", JSON.stringify(this.state.visitin));
      // condition tosxet state
      if (this.state.visitin !== null) {
        this.state.visitin.map(async (item) => {
          if (item.id === this.state.scheduledclientid) {
            this.setState({
              dateOut: item.dateOut,
              latitudeOut: item.latitudeout,
              longitudeOut: item.longitudeOut,
              disableout: item.disableout,
              timeOut: item.timeOut,
            });
            localStorage.setItem("DateOut", JSON.stringify(this.state.dateOut));
            localStorage.setItem("TimeOut", JSON.stringify(this.state.timeOut));
          }
        });
      } else {
        this.setState({ visitin: [] });
      }

      const updateCancelReason =
        constantURI() +
        "UpdateCancelReason?token=" +
        this.state.token +
        "&user=" +
        this.state.username +
        "&LineId=" +
        this.state.scheduledclientid +
        "&checkOut=" +
        this.state.dateOut +
        " " +
        this.state.timeOut +
        "&longOut=" +
        this.state.longitudeOut +
        "&latOut=" +
        this.state.latitudeOut +
        "&inv=" +
        this.state.countTrans;
      await temp.map(async (item, index) => {
        const lastIndex = temp.length - 1;
        this.state.vIn = temp[lastIndex];
        if (item.id === this.state.scheduledclientid) {
          // insert fields to tge last object of the array

          this.state.vIn.UrlOut = updateCancelReason;
        }
      });
      await this.setState({ visitin: temp });
      localStorage.setItem("VisitIn", JSON.stringify(this.state.visitin));
      this.setState({ count: this.state.count + 1 });
      await localStorage.setItem(
        "UnsyncedVisitCount",
        JSON.stringify(this.state.count)
      );
      await localStorage.setItem(
        "UnsyncedVisitDay",
        JSON.stringify(this.state.visitin)
      );
      await this.DailySummaryReport();
      await this.LocalDailyVisits(true);
      this.props.history.push("./Client");
    }

    //const ipLocation = require("iplocation");

    //(async () => {
    //    await ipLocation("192.168.137.128");

    //})();
  };
  oncashsale = async () => {
    this.unblock();
    this.props.history.push("/CashSales");
  };

  onpurchase = () => {
    this.unblock();
    this.props.history.push("/Purchase");
  };

  onreceipt = () => {
    this.unblock();
    this.props.history.push("/Receipt");
  };

  onDelivery = () => {
    this.unblock();
    this.props.history.push("/Delivery");
  };

  onreturn = () => {
    this.unblock();
    this.props.history.push("/Return");
  };

  onorder = () => {
    this.unblock();
    this.props.history.push("/Order");
  };

  arrowback = () => {
    this.unblock();
    // Always navigate to the Client list to provide a stable back behavior
    this.props.history.push("/Client");
  };

  visitIn = async () => {
    this.unblock();
    await this.setState({
      cancelRoute: false,
    });
    localStorage.setItem("cancelRoute", JSON.stringify(false));

    const response = await ASAPAuthenticate();
    this.setState({ authenticate: response });

    if (this.state.authenticate) {
      await navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        await this.setState({
          latitudeVisitIn: latitude,
          longitudeVisitIn: longitude,
        });
        localStorage.setItem("latitudeVisitIn", JSON.stringify(latitude));
        localStorage.setItem("longitudeVisitIn", JSON.stringify(longitude));

        const d = new Date();
        d.setDate(d.getDate());

        // array tmep
        var temp = this.state.visits;
        var backup = this.state.backupVisits;

        // insert fields to the object
        this.state.objectVisits.dateVisitIn = d.toISOString().substring(0, 10);
        this.state.objectVisits.timeVisitIn =
          ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);

        this.state.objectVisits.id = this.state.SelectedClient;
        this.state.objectVisits.longitudeVisitIn = longitude;
        this.state.objectVisits.latitudeVisitIn = latitude;
        this.state.objectVisits.name = this.state.landing;
        this.state.objectVisits.code = this.state.SelectedVisitCode;

        // push the objects to the array
        await temp.push(this.state.objectVisits);
        await backup.push(this.state.objectVisits);

        await this.setState({
          visits: temp,
          backupVisits: backup,
          dateVisitIn: d.toISOString().substring(0, 10),
          timeVisitIn:
            ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19),
        });
        localStorage.setItem("visits", JSON.stringify(this.state.visits));
        localStorage.setItem(
          "backupVisits",
          JSON.stringify(this.state.backupVisits)
        );
        console.log(this.state.visits);
      });
      this.setState({ disableI: true });
      localStorage.setItem("disableI", JSON.stringify(true));
      await localStorage.setItem(
        "UnsyncedVisitDayRoute",
        JSON.stringify(this.state.visits)
      );
    } else {
      alert("No connection. No location. You can continue your work normally.");
      const d = new Date();
      d.setDate(d.getDate());
      await this.setState({
        dateVisitIn: d.toISOString().substring(0, 10),
        timeVisitIn:
          ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19),
      });
      console.log(this.state.dateVisitIn);
      console.log(this.state.timeVisitIn);
      // array tmep
      var temp = this.state.visits;
      var backup = this.state.backupVisits;

      // insert fields to the object
      this.state.objectVisits.dateVisitIn = d.toISOString().substring(0, 10);
      this.state.objectVisits.timeVisitIn =
        ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);

      this.state.objectVisits.id = this.state.SelectedClient;
      this.state.objectVisits.longitudeVisitIn = "";
      this.state.objectVisits.latitudeVisitIn = "";
      // push the objects to the array
      await temp.push(this.state.objectVisits);
      await backup.push(this.state.objectVisits);
      await this.setState({ visits: temp, backupVisits: backup });
      console.log(this.state.visits);

      await localStorage.setItem(
        "UnsyncedVisitDayRoute",
        JSON.stringify(this.state.visits)
      );
      this.setState({ disableI: true });
      localStorage.setItem("disableI", JSON.stringify(true));
    }
  };

  visitOut = async () => {
    this.unblock();
    this.setState({ disableO: true });
    localStorage.setItem("disableI", JSON.stringify(false));
    await this.setState({
      cancelRoute: true,
    });
    localStorage.setItem("cancelRoute", JSON.stringify(true));
    const response = await ASAPAuthenticate();
    this.setState({ authenticate: response });

    if (this.state.authenticate) {
      const onPosition = async (position) => {
        const { latitude, longitude } = position.coords;
        this.setState({
          latitudeVisitOut: latitude,
          longitudeVisitOut: longitude,
        });
        localStorage.setItem("latitudeVisitOut", JSON.stringify(latitude));
        localStorage.setItem("longitudeVisitOut", JSON.stringify(longitude));

        this.unblock();
        // current date
        const d = new Date();
        d.setDate(d.getDate());

        // array temp
        var temp = this.state.visits;
        var backup = this.state.backupVisits;
        // lastobject of the array
        await temp.map(async (item, index) => {
          const lastIndex = temp.length - 1;
          this.state.objectVisits = temp[lastIndex];
          if (item.id === this.state.SelectedClient) {
            // insert fields to tge last object of the array
            this.setState({
              dateVisitOut: d.toISOString().substring(0, 10),
              timeVisitOut:
                ("0" + d.getHours()).slice(-2) +
                d.toISOString().substring(13, 19),
            });
            this.state.objectVisits.dateVisitOut = d
              .toISOString()
              .substring(0, 10);
            this.state.objectVisits.timeVisitOut =
              ("0" + d.getHours()).slice(-2) +
              d.toISOString().substring(13, 19);

            this.state.objectVisits.id = this.state.SelectedClient;
            this.state.objectVisits.longitudeVisitOut = longitude;
            this.state.objectVisits.latitudeVisitOut = latitude;
            this.state.objectVisits.visit = "visited";
          }
        });

        await backup.map(async (item, index) => {
          const lastIndex = backup.length - 1;
          this.state.objectVisits = backup[lastIndex];
          if (item.id === this.state.SelectedClient) {
            // insert fields to tge last object of the array
            this.setState({
              dateVisitOut: d.toISOString().substring(0, 10),
              timeVisitOut:
                ("0" + d.getHours()).slice(-2) +
                d.toISOString().substring(13, 19),
            });
            this.state.objectVisits.dateVisitOut = d
              .toISOString()
              .substring(0, 10);
            this.state.objectVisits.timeVisitOut =
              ("0" + d.getHours()).slice(-2) +
              d.toISOString().substring(13, 19);

            this.state.objectVisits.id = this.state.SelectedClient;
            this.state.objectVisits.longitudeVisitOut = longitude;
            this.state.objectVisits.latitudeVisitOut = latitude;
            this.state.objectVisits.visit = "visited";
          }
        });

        const AddOutRoutVisit =
          constantURI() +
          "AddOutRoutVisit?token=" +
          this.state.token +
          "&user=" +
          this.state.username +
          "&partnerid=" +
          this.state.partnerid +
          "&name=" +
          this.state.landing +
          "&reason=" +
          this.state.reason +
          "&checkIn=" + (this.state.dateVisitIn ?         
            ( this.state.dateVisitIn + " " +  this.state.timeVisitIn ) : 
            (d.toISOString().substring(0, 10) + " " + ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19))
          ) +
          "&checkOut=" +
          d.toISOString().substring(0, 10) +
          " " +
          ("0" + d.getHours()).slice(-2) +
          d.toISOString().substring(13, 19) +
          "&longIn=" +
          this.state.longitudeVisitIn +
          "&longOut=" +
          longitude +
          "&latIn=" +
          this.state.latitudeVisitIn +
          "&latOut=" +
          latitude +
          "&customerId=" +
          this.state.SelectedClient;

        await temp.map(async (item, index) => {
          const lastIndex = temp.length - 1;
          this.state.objectVisits = temp[lastIndex];
          if (item.id === this.state.SelectedClient) {
            // insert fields to tge last object of the array

            this.state.objectVisits.Url = AddOutRoutVisit;
          }
        });
        await backup.map(async (item, index) => {
          const lastIndex = backup.length - 1;
          this.state.objectVisits = backup[lastIndex];
          if (item.id === this.state.SelectedClient) {
            // insert fields to tge last object of the array

            this.state.objectVisits.Url = AddOutRoutVisit;
          }
        });

        await this.setState({ visits: temp, backupVisits: backup });

        localStorage.setItem("visits", JSON.stringify(temp));
        localStorage.setItem("backupVisits", JSON.stringify(backup));

        await localStorage.setItem(
          "UnsyncedVisitDayRoute",
          JSON.stringify(this.state.visits)
        );
      };

      // Wait for the visit-out to be saved before leaving the page, otherwise the
      // active-visit route guard still sees the visit open and redirects back here.
      await new Promise((resolve) => {
        let settled = false;
        const finish = (position) => {
          if (settled) return;
          settled = true;
          Promise.resolve(onPosition(position))
            .catch((error) => console.error("Visit out failed:", error))
            .finally(resolve);
        };
        const fallback = () =>
          finish({ coords: { latitude: "", longitude: "" } });
        if (!navigator.geolocation) {
          fallback();
          return;
        }
        navigator.geolocation.getCurrentPosition(finish, fallback, {
          timeout: 15000,
          maximumAge: 60000,
        });
        setTimeout(fallback, 20000);
      });
    } else {
      alert("Geolocation is not supported by this browser.");
      this.setState({
        latitudeVisitOut: 0,
        longitudeVisitOut: 0,
      });
      localStorage.setItem("latitudeVisitOut", JSON.stringify(0));
      localStorage.setItem("longitudeVisitOut", JSON.stringify(0));

      this.unblock();
      // current date
      const d = new Date();
      d.setDate(d.getDate());

      // array temp
      var temp = this.state.visits;
      var backup = this.state.backupVisits;
      // lastobject of the array
      await temp.map(async (item, index) => {
        const lastIndex = temp.length - 1;
        this.state.objectVisits = temp[lastIndex];
        if (item.id === this.state.SelectedClient) {
          // insert fields to tge last object of the array
          this.state.objectVisits.dateVisitOut = d
            .toISOString()
            .substring(0, 10);
          this.state.objectVisits.timeVisitOut =
            ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);

          this.state.objectVisits.id = this.state.SelectedClient;
          this.state.objectVisits.longitudeVisitOut = "";
          this.state.objectVisits.latitudeVisitOut = "";
          this.state.objectVisits.visit = "visited";
        }
      });

      await backup.map(async (item, index) => {
        const lastIndex = backup.length - 1;
        this.state.objectVisits = backup[lastIndex];
        if (item.id === this.state.SelectedClient) {
          // insert fields to tge last object of the array
          this.state.objectVisits.dateVisitOut = d
            .toISOString()
            .substring(0, 10);
          this.state.objectVisits.timeVisitOut =
            ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19);

          this.state.objectVisits.id = this.state.SelectedClient;
          this.state.objectVisits.longitudeVisitOut = "";
          this.state.objectVisits.latitudeVisitOut = "";
          this.state.objectVisits.visit = "visited";
        }
      });

      const AddOutRoutVisit =
        constantURI() +
        "AddOutRoutVisit?token=" +
        this.state.token +
        "&user=" +
        this.state.username +
        "&partnerid=" +
        this.state.partnerid +
        "&name=" +
        this.state.landing +
        "&reason=" +
        this.state.reason +
        "&checkIn=" + (this.state.dateVisitIn ?         
          ( this.state.dateVisitIn + " " +  this.state.timeVisitIn ) : 
          (d.toISOString().substring(0, 10) + " " + ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19))
        ) +
        "&checkOut=" +
        d.toISOString().substring(0, 10) +
        " " +
        ("0" + d.getHours()).slice(-2) +
        d.toISOString().substring(13, 19) +
        "&longIn=" +
        "" +
        "&longOut=" +
        "" +
        "&latIn=" +
        "" +
        "&latOut=" +
        "" +
        "&customerId=" +
        this.state.SelectedClient;

      await temp.map(async (item, index) => {
        const lastIndex = temp.length - 1;
        this.state.objectVisits = temp[lastIndex];
        if (item.id === this.state.SelectedClient) {
          // insert fields to tge last object of the array

          this.state.objectVisits.Url = AddOutRoutVisit;
        }
      });

      await backup.map(async (item, index) => {
        const lastIndex = backup.length - 1;
        this.state.objectVisits = backup[lastIndex];
        if (item.id === this.state.SelectedClient) {
          // insert fields to tge last object of the array

          this.state.objectVisits.Url = AddOutRoutVisit;
        }
      });
      await this.setState({ visits: temp, backupVisits: backup });

      localStorage.setItem("visits", JSON.stringify(temp));
      localStorage.setItem("backupVisits", JSON.stringify(backup));

      await localStorage.setItem(
        "UnsyncedVisitDayRoute",
        JSON.stringify(this.state.visits)
      );
    }

    this.props.history.push("./Client");
  };

  startlocation = async () => {
    this.setState({ locationDisabled: true });
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      await navigator.geolocation.getCurrentPosition(async (position) => {
        localStorage.setItem(
          "LatitudeClient",
          JSON.stringify(position.coords.latitude)
        );
        localStorage.setItem(
          "LongitudeClient",
          JSON.stringify(position.coords.longitude)
        );

        var temp = this.state.clientLocation;
        const UpdateClientLocation =
          constantURI() +
          "UpdateClientLocation?token=" +
          this.state.token +
          "&user=" +
          this.state.username +
          "&longitude=" +
          position.coords.longitude +
          "&latitude=" +
          position.coords.latitude +
          "&customerId=" +
          this.state.SelectedClient;

        this.state.locationObject.Url = UpdateClientLocation;
        this.state.locationObject.id = this.state.SelectedClient;
        this.state.locationObject.longitudeClient = position.coords.longitude;
        this.state.locationObject.latitudeClient = position.coords.latitude;

        // temp.map(async (object) => {
        //   if (object.SelectedClient === this.state.SelectedClient) {
        //   } else {
        //     await temp.push(this.state.locationObject);
        //     this.setState({
        //       clientLocation: temp,
        //     });
        //   }
        // });
        // push the objects to the array

        const { SelectedClient, locationObject } = this.state;

        // Create a new array with updated or added location object
        let updatedTemp = temp.map((object) => {
          if (object.id === SelectedClient) {
            // Update the object with locationObject
            return { ...object, ...locationObject };
          }
          return object;
        });

        // Check if the client was already updated
        const isClientUpdated = temp.some(
          (object) => object.id === SelectedClient
        );

        // If no match was found, add a new object
        if (!isClientUpdated) {
          // updatedTemp = [...updatedTemp, locationObject];
          await updatedTemp.push(this.state.locationObject);
          this.setState({ clientLocation: updatedTemp });
          localStorage.setItem(
            "clientLocation",
            JSON.stringify(this.state.clientLocation)
          );
        }

        // Update the state with the new array
        // this.setState({ clientLocation: updatedTemp }, () => {
        //   // Save to localStorage after state is updated
        //   localStorage.setItem("clientLocation", JSON.stringify(this.state.clientLocation));
        // });
      });
    } else {
      alert("No Connection No location");
    }
  };

  render() {
    console.log(this.state.settingArray);
    return (
      <div className="container-fluid vh-100" style={stylesASAP.mainContainer}>
        {!this.state.alertUndefined ? null : (
          <div className="col alert alert-danger">
            <div className="row">
              <h6 className="col-sm-8">There seems to be a problem.</h6>
              <div className="col d-flex flex-row-reverse">
                <div
                  className="btn"
                  style={stylesMed.wideButton}
                  onClick={() => window.location.reload()}
                >
                  Reload
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="pt-3 row">
          {this.state.isSchedule !== 1 ? (
            <div className="row text-center mt-3">
              {this.state.settingArray.map((item) => {
                if (item.key === "Enable_Out_of_Route_Schedule") {
                  return item.value !== "1" ? (
                    <div className="col-1 floatLeft">
                      <ArrowBackCircle
                        className="btn"
                        onClick={() => this.arrowback()}
                        color={"#65a0ff"}
                        height="45px"
                        width="45px"
                      />
                    </div>
                  ) : null;
                }
              })}

              {/* {this.state.settingArray.length === 0 ? (
                <div className="col-1 floatLeft">
                  <ArrowBackCircle
                    className="btn"
                    onClick={() => this.arrowback()}
                    color={"#65a0ff"}
                    height="45px"
                    width="45px"
                  />
                </div>
              ) : null} */}
              <div className="col-12">
                <div className="card text-center ">
                  <div className="card-header catalog text-white ">
                    <FontAwesomeIcon icon={faUser} /> User Information
                  </div>
                  <div className="card-body Box-Shadow">
                    <div className="row align-items-center justify-content-center card-footer text-muted ">
                      <div className="col-md-4">
                        <FontAwesomeIcon icon={faUser} />{" "}
                        <b>Name: {this.state.clientDetail.name}</b>
                      </div>
                      <div className="col-md-4">
                        <FontAwesomeIcon icon={faUser} />{" "}
                        <b>Code: {this.state.clientDetail.Ref}</b>
                      </div>
                      <div className="col-md-4">
                        <FontAwesomeIcon icon={faMapMarkerAlt} />{" "}
                        {(this.state.clientDetail.city !== "false" ||
                          this.state.clientDetail.street2 !== "false") && (
                          <b>
                            Location:{" "}
                            {[
                              this.state.clientDetail.city,
                              this.state.clientDetail.street2,
                            ]
                              .filter((v) => v !== "false")
                              .join(" ")}
                          </b>
                        )}
                        {/* <b>Location: {this.state.clientDetail.city + "" + this.state.clientDetail.street2}</b> */}
                      </div>
                    </div>

                    <div className="row align-items-center justify-content-center card-footer text-muted ">
                      <div className="col-md-4">
                        <FontAwesomeIcon icon={faPhone} />
                        <b>Phone: {this.state.clientDetail.mobile}</b>{" "}
                      </div>
                      <div className="col-md">
                        <FontAwesomeIcon icon={faFileInvoiceDollar} />{" "}
                        {this.state.clientDetail.last_sales_order !==
                          undefined &&
                        this.state.clientDetail.last_sales_order.length !==
                          0 ? (
                          <b>
                            Last Sales Order :{" "}
                            {this.state.clientDetail.last_sales_order[0]
                              .amount_total +
                              " " +
                              this.state.clientDetail.last_sales_order[0]
                                .currency}
                          </b>
                        ) : null}
                      </div>
                      <div className="col-md">
                        <FontAwesomeIcon icon={faCheckCircle} />{" "}
                        {this.state.clientDetail.last_sales_order !==
                          undefined &&
                        this.state.clientDetail.last_sales_order.length !==
                          0 ? (
                          <b>
                            Date :{" "}
                            {
                              this.state.clientDetail.last_sales_order[0]
                                .date_order
                            }
                          </b>
                        ) : null}
                      </div>
                      {this.state.settingArray.map((st, index) =>
                        st.key === "CustomerBalance" && st.value === "1" ? (
                          <div className="col-md" key={index}>
                            <FontAwesomeIcon icon={faScaleBalanced} />{" "}
                            {this.state.clientDetail.balance !== undefined ? (
                              <b>
                                {"Balance "}
                                {this.state.clientDetail.balance +
                                  " " +
                                  this.state.clientDetail.currency_id[1]}
                              </b>
                            ) : null}
                          </div>
                        ) : null
                      )}
                      {this.state.settingArray.map((st, index) =>
                        st.key === "CustomerCreditLimit" && st.value === "1" ? (
                          <div className="col-md" key={index}>
                            <FontAwesomeIcon icon={faCreditCard} />{" "}
                            {this.state.clientDetail.credit_limit !==
                            undefined ? (
                              <b>
                                {"Credit Limit "}
                                {this.state.clientDetail.credit_limit +
                                  " " +
                                  this.state.clientDetail.currency_id[1]}
                              </b>
                            ) : null}
                          </div>
                        ) : null
                      )}

                      {this.state.settingArray.map((st, index) =>
                        st.key === "EnableCustomerSetLocation" &&
                        st.value === "1" ? (
                          this.state.LatitudeClient !== 0 &&
                          this.state.LongitudeClient !== 0 ? null : this.state
                              .locationDisabled ? (
                            <div className="col-md mt-3">
                              {" "}
                              <button
                                className="btn btn-success disabled"
                                onClick={() => this.startlocation()}
                                color={"#65a0ff"}
                                height="50px"
                                width="50px"
                              >
                                Start Location{" "}
                              </button>
                            </div>
                          ) : (
                            <div className="col-md mt-3">
                              {" "}
                              <button
                                className="btn btn-success"
                                onClick={() => this.startlocation()}
                                color={"#65a0ff"}
                                height="50px"
                                width="50px"
                              >
                                Start Location{" "}
                              </button>
                            </div>
                          )
                        ) : null
                      )}

                      {/* {this.state.settingArray.map((st) => {
                        if (
                          st.key === "EnableCustomerSOA" &&
                          (st.value === "1")
                        ) {
                          <button
                            className="btn btn-success"
                            onClick={() => this.statmentofaccount()}
                            color={"#65a0ff"}
                            height="50px"
                            width="50px"
                          >
                            Statment of account{" "}
                          </button>;
                        }
                      })} */}
                      {this.state.settingArray.find(
                        (st) =>
                          st.key === "EnableCustomerSOA" && st.value === "1"
                      ) && (
                        <button
                          className="btn btn-secondary mt-2"
                          onClick={() => this.statmentofaccount()}
                          color={"#65a0ff"}
                          height="50px"
                          width="50px"
                        >
                          Statement of account
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          <div className="col d-flex flex-row-reverse align-items-center" style={{ gap: 8 }}>
            {(this.state.isSchedule === 1 ? !this.state.disableDate : !this.state.disableI) ? (
              <ArrowBackCircle
                className="btn"
                onClick={() => this.arrowback()}
                color={"#6C757D"}
                height="50px"
                width="50px"
              />
            ) : null}
          </div>
          {this.state.isSchedule === 1 ? (
            <div className="row text-center mt-4">
              {/* Show Visit In only before starting visit */}
              {!this.state.disableDate ? (
                <div className="col floatLeft">
                  <div
                    className={"btn dateInOut"}
                    onClick={this.DateIn}
                  >
                    <b>Visit In</b>
                  </div>
                  <p className="col mt-3">
                    {this.state.dateIn === null || this.state.timeIn === null
                      ? null
                      : this.state.dateIn + " " + this.state.timeIn}
                  </p>
                </div>
              ) : null}

              {/* Right column: show Visit Out when available, otherwise show Cancel Visit */}
              {this.state.disableDate ? (
                <div className="col floatRight">
                  <div
                    className={
                      !this.state.disableout
                        ? "btn dateInOut"
                        : "btn disabled dateInOut"
                    }
                    onClick={this.DateOut}
                  >
                    <b>Visit Out</b>
                  </div>
                  <p className="col mt-3">
                    {this.state.dateOut === null || this.state.timeOut === null
                      ? null
                      : this.state.dateOut + " " + this.state.timeOut}
                  </p>
                </div>
              ) : (
                <div className="col floatRight">
                  <div
                    className={
                      !this.state.disableout && !this.state.reasonDisable
                        ? "btn btn-danger"
                        : "btn btn-danger disabled"
                    }
                    onClick={this.showAlertCancel}
                  >
                    Cancel Visit
                  </div>
                </div>
              )}
            </div>
          ) : (
            this.state.settingArray.map((item) => {
              if (item.key === "Enable_Out_of_Route_Schedule") {
                return item.value === "1" ? (
                  <div className="row text-center mt-4">
                    {/* Show Visit In only before starting visit */}
                    {!this.state.disableI ? (
                      <div className="col floatLeft">
                        <div
                          className={"btn dateInOut"}
                          onClick={this.visitIn}
                        >
                          <b>Visit In</b>
                        </div>
                        <p className="col mt-3">
                          {this.state.dateVisitIn === null ||
                        this.state.timeVisitIn === null
                          ? null
                          : this.state.dateVisitIn +
                            " " +
                            this.state.timeVisitIn}
                        </p>
                      </div>
                    ) : null}

                    {/* Right column: show Visit Out when available, otherwise show Cancel Visit */}
                    {this.state.disableI && !this.state.disableO ? (
                      <div className="col floatRight">
                        <div
                          className={
                            !this.state.disableO
                              ? "btn dateInOut"
                              : "btn disabled dateInOut"
                          }
                          onClick={this.visitOut}
                        >
                          <b>Visit Out</b>
                        </div>
                        <p>
                          {this.state.dateVisitOut === null ||
                          this.state.timeVisitOut === null
                            ? null
                            : this.state.dateVisitOut +
                              " " +
                              this.state.timeVisitOut}
                        </p>
                      </div>
                    ) : (
                      <div className="col floatRight">
                        <div
                          className={
                            !this.state.disableI
                              ? "btn btn-danger"
                              : "btn btn-danger disabled"
                          }
                          onClick={this.showAlertCancel}
                        >
                          Cancel Visit
                        </div>
                      </div>
                    )}
                  </div>
                ) : null;
              }
            })
          )}
        </div>
        {this.state.currentType === 1 ? (
          <div className="mt-3" style={stylesASAP.mainContainer}>
            <div className="row">
              <div
                className="btn col Box-Shadow text-center m-2"
                onClick={() => this.onpurchase()}
              >
                <PeopleOutline
                  className="row align-items-center justify-content-center"
                  color={"#65a0ff"}
                  height="150px"
                  width="150px"
                />
                <h4 className="card-text" style={stylesASAP.itemName}>
                  POs
                </h4>
              </div>
              <div
                className="btn col Box-Shadow text-center m-2"
                onClick={() => this.onreceipt()}
              >
                <ReceiptOutline
                  className="row align-items-center justify-content-center"
                  color={"#65a0ff"}
                  height="150px"
                  width="150px"
                />
                <h4 className="card-text" style={stylesASAP.itemName}>
                  Payement
                </h4>
              </div>
              {this.state.settingArray.find(st=>st.key==='Competitor' && st.value==='enabled') && (() => {
                const enabled = this.state.disableDate && !this.state.disableout;
                return (
                  <div
                    className={
                      enabled
                        ? "btn col Box-Shadow text-center m-2"
                        : "btn col Box-Shadow text-center m-2 disabled"
                    }
                    onClick={enabled ? () => this.logCompetitor() : undefined}
                    aria-disabled={!enabled}
                  >
                    <FcShop
                      className="row align-items-center justify-content-center"
                      color={"#65a0ff"}
                      size={60}
                    />
                    <h4 className="card-text" style={stylesASAP.itemName}>
                      Log Competitor
                    </h4>
                  </div>
                );
              })()}
            </div>
            <div className="row">
              {/* <div
                className="btn col Box-Shadow text-center m-2"
                onClick={() => this.onDelivery()}
              >
                <LogOutOutline
                  className="row align-items-center justify-content-center"
                  color={"#65a0ff"}
                  height="150px"
                  width="150px"
                />
                <h4 className="card-text" style={stylesASAP.itemName}>
                  Delivery
                </h4>
              </div> */}
              <div
                className="btn col Box-Shadow text-center m-2 invisible"
                onClick={this.showAlertChange}
              >
                <LogOutOutline
                  className="row align-items-center justify-content-center"
                  color={"#65a0ff"}
                  height="150px"
                  width="150px"
                />
                <h4 className="card-text" style={stylesASAP.itemName}>
                  Logout
                </h4>
              </div>
            </div>
          </div>
        ) : this.state.isSchedule === 1 ? (
          <div className="mt-3" style={stylesASAP.mainContainer}>
            <div className="row">
              {this.featureEnabled("Enable_SalesOrder") && (
              <div
                className={
                  this.state.disableDate && !this.state.disableout
                    ? "btn col Box-Shadow text-center m-2"
                    : "btn col Box-Shadow text-center m-2 disabled"
                }
                style={stylesASAP.mainContainer}
                onClick={() => this.onorder()}
              >
                <CartOutline
                  className="row align-items-center justify-content-center"
                  color={"#65a0ff"}
                  height="150px"
                  width="150px"
                />
                <h4 className="card-text" style={stylesASAP.itemName}>
                  Sales Order
                </h4>
              </div>
              )}
              {this.featureEnabled("Enable_Return") && (
              <div
                className={
                  this.state.disableDate && !this.state.disableout
                    ? "btn col Box-Shadow text-center m-2"
                    : "btn col Box-Shadow text-center m-2 disabled"
                }
                style={stylesASAP.mainContainer}
                onClick={() => this.onreturn()}
              >
                <ReturnUpBackOutline
                  className="row align-items-center justify-content-center"
                  color={"#65a0ff"}
                  height="150px"
                  width="150px"
                />
                <h4 className="card-text" style={stylesASAP.itemName}>
                  Returns
                </h4>
              </div>
              )}
            </div>
            <div className="row">
              {this.featureEnabled("Enable_Receipt") && (
              <div
                className={
                  this.state.disableDate && !this.state.disableout
                    ? "btn col Box-Shadow text-center m-2"
                    : "btn col Box-Shadow text-center m-2 disabled"
                }
                style={stylesASAP.mainContainer}
                onClick={() => this.onreceipt()}
              >
                <ReceiptOutline
                  className="row align-items-center justify-content-center"
                  color={"#65a0ff"}
                  height="150px"
                  width="150px"
                />
                <h4 className="card-text" style={stylesASAP.itemName}>
                  Receipts
                </h4>
              </div>
              )}
              {this.state.settingArray.find(st=>st.key==='Competitor' && st.value==='enabled') && (() => {
                const enabled = this.state.disableDate && !this.state.disableout;
                return (
                  <div
                    className={
                      enabled
                        ? "btn col Box-Shadow text-center m-2"
                        : "btn col Box-Shadow text-center m-2 disabled"
                    }
                    onClick={enabled ? () => this.logCompetitor() : undefined}
                    aria-disabled={!enabled}
                  >
                    <FcShop
                      className="row align-items-center justify-content-center"
                      color={"#65a0ff"}
                      size={60}
                    />
                    <h4 className="card-text" style={stylesASAP.itemName}>
                      Log Competitor
                    </h4>
                  </div>
                );
              })()}
              {/* <div
                className={
                  this.state.disableDate && !this.state.disableout
                    ? "btn col Box-Shadow text-center m-2"
                    : "btn col Box-Shadow text-center m-2 disabled"
                }
                style={stylesASAP.mainContainer}
                onClick={() => this.onDelivery()}
              >
                <LogOutOutline
                  className="row align-items-center justify-content-center"
                  color={"#65a0ff"}
                  height="150px"
                  width="150px"
                />
                <h4 className="card-text" style={stylesASAP.itemName}>
                  Delivery
                </h4>
              </div> */}
            </div>
            <div className="row">
              <div
                className="btn col Box-Shadow text-center m-2 invisible"
                style={stylesASAP.mainContainer}
                onClick={this.showAlertChange}
              >
                <LogOutOutline
                  className="row align-items-center justify-content-center"
                  color={"#65a0ff"}
                  height="150px"
                  width="150px"
                />
                <h4 className="card-text" style={stylesASAP.itemName}>
                  Logout
                </h4>
              </div>
              <div
                className="btn col Box-Shadow text-center m-2 invisible"
                style={stylesASAP.mainContainer}
                onClick={this.showAlertChange}
              >
                <LogOutOutline
                  className="row align-items-center justify-content-center"
                  color={"#65a0ff"}
                  height="150px"
                  width="150px"
                />
                <h4 className="card-text" style={stylesASAP.itemName}>
                  Logout
                </h4>
              </div>
            </div>
          </div>
        ) : (
          <div className="mt-3">
            {this.state.settingArray.map((item) => {
              if (item.key === "Enable_Out_of_Route_Schedule") {
                return item.value !== "1" ? (
                  <div>
                    <div class="row mt-5" style={{ clear: "both" }}>
                    {this.featureEnabled("Enable_SalesOrder") && (
                    <div class="col-sm-6 ">
                      <div class="card bg-c-blue Box-Shadow order-card">
                        <div
                          className={"btn card-block"}
                          onClick={() => this.onorder()}
                        >
                          <FcShop className="text-center" size={60} />
                          <h3
                            className="m-b-20 text-center m-2 mb-2"
                            style={{ color: "white" }}
                          >
                            Sales Order
                          </h3>
                        </div>
                      </div>
                    </div>
                    )}

                    {this.featureEnabled("Enable_Return") && (
                    <div class="col-sm-6 ">
                      <div class="card bg-c-blue order-card Box-Shadow">
                        <div
                          className={"btn card-block"}
                          onClick={() => this.onreturn()}
                        >
                          <FcProcess size={60} />
                          <h3
                            class="m-b-20 text-center m-2 mb-2"
                            style={{ color: "white" }}
                          >
                            Return
                          </h3>
                        </div>
                      </div>
                    </div>
                    )}

                    {this.featureEnabled("Enable_Receipt") && (
                    <div class="col-sm-6 ">
                      <div class="card bg-c-blue Box-Shadow order-card">
                        <div
                          className={"btn card-block"}
                          onClick={() => this.onreceipt()}
                        >
                          <FcNook className="text-center" size={60} />
                          <h3
                            class="m-b-20 text-center m-2 mb-2"
                            style={{ color: "white" }}
                          >
                            Receipt
                          </h3>
                        </div>
                      </div>
                    </div>
                    )}
                    {this.featureEnabled("Enable_CashSales") && (
                    <div class="col-sm-6 ">
                      <div class="card bg-c-blue Box-Shadow order-card">
                        <div
                          className={"btn card-block"}
                          onClick={() => this.oncashsale()}
                        >
                          <FcPaid className="text-center" size={60} />
                          <h3
                            class="m-b-20 text-center m-2 mb-2"
                            style={{ color: "white" }}
                          >
                            Cash Sales
                          </h3>
                        </div>
                      </div>
                    </div>
                    )}

                    {this.state.settingArray.find(st=>st.key==='Competitor' && st.value==='enabled') ? (
                    <div className="col-sm-6 ">
                        <div className="card bg-c-blue order-card Box-Shadow">
                          <div
                            className={
                              this.state.disableDate && !this.state.disableout
                                ? "btn card-block"
                                : "btn card-block disabled"
                            }
                            onClick={() => this.logCompetitor()}
                          >
                            <FcShop size={60} />
                            <h3
                              className="m-b-20 text-center m-2 mb-2"
                              style={{ color: "white" }}
                            >
                              Log Competitor
                            </h3>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                ) : (
                  <div>
                    <div class="row mt-5" style={{ clear: "both" }}>
                    {this.featureEnabled("Enable_SalesOrder") && (
                    <div class="col-sm-6 ">
                      <div class="card bg-c-blue Box-Shadow order-card">
                        <div
                          className={
                            this.state.disableI && !this.state.disableO
                              ? "btn card-block"
                              : "btn card-block disabled"
                          }
                          onClick={() => this.onorder()}
                        >
                          <FcShop className="text-center" size={60} />
                          <h3
                            class="m-b-20 text-center m-2 mb-2"
                            style={{ color: "white" }}
                          >
                            Sales Order
                          </h3>
                        </div>
                      </div>
                    </div>
                    )}

                    {this.featureEnabled("Enable_Return") && (
                    <div class="col-sm-6 ">
                      <div class="card bg-c-blue order-card Box-Shadow">
                        <div
                          className={
                            this.state.disableI && !this.state.disableO
                              ? "btn card-block"
                              : "btn card-block disabled"
                          }
                          onClick={() => this.onreturn()}
                        >
                          <FcProcess size={60} />
                          <h3
                            class="m-b-20 text-center m-2 mb-2"
                            style={{ color: "white" }}
                          >
                            Return
                          </h3>
                        </div>
                      </div>
                    </div>
                    )}

                    {this.featureEnabled("Enable_Receipt") && (
                    <div class="col-sm-6 ">
                      <div class="card bg-c-blue Box-Shadow order-card">
                        <div
                          className={
                            this.state.disableI && !this.state.disableO
                              ? "btn card-block"
                              : "btn card-block disabled"
                          }
                          onClick={() => this.onreceipt()}
                        >
                          <FcNook className="text-center" size={60} />
                          <h3
                            class="m-b-20 text-center m-2 mb-2"
                            style={{ color: "white" }}
                          >
                            Receipt
                          </h3>
                        </div>
                      </div>
                    </div>
                    )}
                    {this.featureEnabled("Enable_CashSales") && (
                    <div class="col-sm-6 ">
                      <div class="card bg-c-blue Box-Shadow order-card">
                        <div
                          className={
                            this.state.disableI && !this.state.disableO
                              ? "btn card-block"
                              : "btn card-block disabled"
                          }
                          onClick={() => this.oncashsale()}
                        >
                          <FcPaid className="text-center" size={60} />
                          <h3
                            class="m-b-20 text-center m-2 mb-2"
                            style={{ color: "white" }}
                          >
                            Cash Sales
                          </h3>
                        </div>
                      </div>
                    </div>
                    )}

                    {this.state.settingArray.find(st=>st.key==='Competitor' && st.value==='enabled') ? (
                    <div className="col-sm-6 ">
                        <div className="card bg-c-blue order-card Box-Shadow">
                          <div
                            className={
                              this.state.disableI && !this.state.disableO
                                ? "btn card-block"
                                : "btn card-block disabled"
                            }
                            onClick={() => this.logCompetitor()}
                          >
                            <FcShop size={60} />
                            <h3
                              className="m-b-20 text-center m-2 mb-2"
                              style={{ color: "white" }}
                            >
                              Log Competitor
                            </h3>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                    </div>
                );
              }
            })}
            {/* <div class="row mt-5" style={{ clear: "both" }}>
              <div class="col-sm-6 ">
                <div class="card bg-c-blue Box-Shadow order-card">
                  <div
                    className={
                      this.state.disableI && !this.state.disableO
                        ? "btn card-block"
                        : "btn card-block disabled"
                    }
                    onClick={() => this.onorder()}
                  >
                    <FcShop className="text-center" size={60} />
                    <h3
                      class="m-b-20 text-center m-2 mb-2"
                      style={{ color: "white" }}
                    >
                      Sales Order
                    </h3>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 ">
                <div class="card bg-c-blue order-card Box-Shadow">
                  <div
                    className={
                      this.state.disableI && !this.state.disableO
                        ? "btn card-block"
                        : "btn card-block disabled"
                    }
                    onClick={() => this.onreturn()}
                  >
                    <FcProcess size={60} />
                    <h3
                      class="m-b-20 text-center m-2 mb-2"
                      style={{ color: "white" }}
                    >
                      Return
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" style={{ clear: "both" }}>
              <div class="col-sm-6 ">
                <div class="card bg-c-blue Box-Shadow order-card">
                  <div
                    className={
                      this.state.disableI && !this.state.disableO
                        ? "btn card-block"
                        : "btn card-block disabled"
                    }
                    onClick={() => this.onreceipt()}
                  >
                    <FcNook className="text-center" size={60} />
                    <h3
                      class="m-b-20 text-center m-2 mb-2"
                      style={{ color: "white" }}
                    >
                      Receipt
                    </h3>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 ">
                <div class="card bg-c-blue Box-Shadow order-card">
                  <div
                    className={
                      this.state.disableI && !this.state.disableO
                        ? "btn card-block"
                        : "btn card-block disabled"
                    }
                    onClick={() => this.oncashsale()}
                  >
                    <FcPaid className="text-center" size={60} />
                    <h3
                      class="m-b-20 text-center m-2 mb-2"
                      style={{ color: "white" }}
                    >
                      Cash Sales
                    </h3>
                  </div>
                </div>
              </div>
          
            </div>

            <div class="row" style={{ clear: "both" }}>
              <div class="col-sm-6 ">
                <div class="card bg-c-blue order-card Box-Shadow invisible">
                  <div
                    className={"btn card-block"}
                    onClick={() => this.onDelivery()}
                  >
                    <FcSurvey size={60} />
                    <h3
                      class="m-b-20 text-center m-2 mb-2"
                      style={{ color: "white" }}
                    >
                      Delivery
                    </h3>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        )}
        <Modal
          show={this.state.showAlertAging}
          onHide={this.closeAlertAging}
          animation={false}
        >
          <Modal.Header>
            <div className="text-center">
              <h3>Aging</h3>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div>
              <div className="row mt-3">
                <div className="col">
                  <div className="text-center agency h6">
                    <b>Last Sales Order</b>
                  </div>

                  <div className="row mb-3">
                    <div className="col mt-3"></div>
                    <div className="col mt-3">{this.state.clientDetail.last_sales_order && this.state.clientDetail.last_sales_order.length > 0 ? this.state.clientDetail.last_sales_order[0].date_order : ""}</div>
                    <div className="col mt-3">{this.state.clientDetail.last_sales_order && this.state.clientDetail.last_sales_order.length > 0 ? (this.state.clientDetail.last_sales_order[0].amount_total + " " + (this.state.clientDetail.last_sales_order[0].currency || "")) : ""}</div>
                    <div className="col mt-3"></div>
                  </div>
                </div>

                <div className="col">
                  <div className="text-center agency h6">
                    <b>Last Invoice</b>
                  </div>

                  <div className="row mb-3">
                    <div className="col mt-3"></div>
                    <div className="col mt-3">{this.state.clientDetail.last_invoice ? this.state.clientDetail.last_invoice.date_invoice : ""}</div>
                    <div className="col mt-3">{this.state.clientDetail.last_invoice ? (this.state.clientDetail.last_invoice.amount_total + " " + (this.state.clientDetail.last_invoice.currency || "")) : ""}</div>
                    <div className="col mt-3"></div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showAlertChange}
          onHide={this.closeAlertChange}
          animation={false}
        >
          <Modal.Header>
            <h5>Logout</h5>
          </Modal.Header>
          <Modal.Body>Are You Sure You Want To Logout?</Modal.Body>
          <Modal.Body>
            <div>
              <div
                className="btn btn-primary"
                style={stylesASAP.deleteButtonAlert}
                onClick={() => this.props.history.push("./")}
              >
                Logout
              </div>
              <div
                className="btn btn-danger"
                style={stylesASAP.deleteButtonAlert}
                onClick={() => this.closeAlertChange()}
              >
                Cancel
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showAlertCancel}
          onHide={this.closeAlertCancel}
          animation={false}
        >
          <Modal.Header>
            <h4 className="text-center"> Cancel Visit Reason</h4>
          </Modal.Header>
          <Modal.Body>
            Are You Sure You Want To Cancel The Visit ? Why ?
          </Modal.Body>
          <Modal.Body>
            {this.state.settingArray.map((item) => {
              if (item.key === "Visit_Cancel_Reason_Type") {
                return item.value === "dropdown" ? (
                  <div>
                    <select
                      className="col form-control"
                      style={
                        this.state.alertdanger
                          ? stylesASAP.wideButtonRequired
                          : null
                      }
                      onChange={this.onChangeReason}
                      value={this.state.reason}
                    >
                      <option value="" disabled>
                        Select a reason...
                      </option>
                      {this.state.settingArray
                        .filter(
                          (item) => item.key === "Visit_Cancel_Reason_Options"
                        )
                        .map((item, index) =>
                          item.value
                            .split(",")
                            .map((reason, i) => (
                              <option value={reason}>{reason}</option>
                            ))
                        )}
                    </select>

                    {this.state.isSchedule === 1 ? (
                      <div className="pt-4 row">
                        <div className="col">
                          <div
                            className="btn btn-primary"
                            style={stylesASAP.Reason}
                            onClick={this.SaveReason}
                          >
                            Save
                          </div>
                        </div>
                        <div className="col d-flex flex-row-reverse">
                          <div
                            className="btn btn-danger"
                            style={stylesASAP.Reason}
                            onClick={this.closeAlertCancel}
                          >
                            Cancel
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="pt-4 row">
                        <div className="col">
                          {this.state.savedisable === true ? (
                            <div
                              className="btn btn-primary disabled"
                              style={stylesASAP.Reason}
                              onClick={this.SaveReason2}
                            >
                              Save
                            </div>
                          ) : (
                            <div
                              className="btn btn-primary"
                              style={stylesASAP.Reason}
                              onClick={this.SaveReason2}
                            >
                              Save
                            </div>
                          )}
                        </div>
                        <div className="col d-flex flex-row-reverse">
                          <div
                            className="btn btn-danger"
                            style={stylesASAP.Reason}
                            onClick={this.closeAlertCancel}
                          >
                            Cancel
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    <input
                      className="col form-control"
                      style={
                        this.state.alertdanger
                          ? stylesASAP.wideButtonRequired
                          : null
                      }
                      onChange={this.onChangeReason}
                      placeholder="Please Enter The Reason"
                    />
                    {item.key === "isScheduling" ? (
                      item.value === "1" ? (
                        <div className="pt-4 row">
                          <div className="col">
                            <div
                              className="btn btn-primary"
                              style={stylesASAP.Reason}
                              onClick={this.SaveReason}
                            >
                              Save
                            </div>
                          </div>
                          <div className="col d-flex flex-row-reverse">
                            <div
                              className="btn btn-danger"
                              style={stylesASAP.Reason}
                              onClick={this.closeAlertCancel}
                            >
                              Cancel
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="pt-4 row">
                          <div className="col">
                            {this.state.savedisable === true ? (
                              <div
                                className="btn btn-primary disabled"
                                style={stylesASAP.Reason}
                                onClick={this.SaveReason2}
                              >
                                Save
                              </div>
                            ) : (
                              <div
                                className="btn btn-primary"
                                style={stylesASAP.Reason}
                                onClick={this.SaveReason2}
                              >
                                Save
                              </div>
                            )}
                          </div>
                          <div className="col d-flex flex-row-reverse">
                            <div
                              className="btn btn-danger"
                              style={stylesASAP.Reason}
                              onClick={this.closeAlertCancel}
                            >
                              Cancel
                            </div>
                          </div>
                        </div>
                      )
                    ) : null}
                  </div>
                );
              }
            })}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
